import { useState } from 'react'
import { loginWithGoogle, loginWithEmail, registerWithEmail } from '../lib/firebase'

export default function AuthModal({ onClose, onSuccess }) {
  const [mode, setMode] = useState('login') // 'login' | 'register'
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const handleGoogle = async () => {
    setError('')
    setLoading(true)
    try {
      await loginWithGoogle()
      onSuccess?.()
    } catch (e) {
      setError('Googleログインに失敗しました。')
    } finally {
      setLoading(false)
    }
  }

  const handleEmail = async (e) => {
    e.preventDefault()
    setError('')
    setLoading(true)
    try {
      if (mode === 'login') {
        await loginWithEmail(email, password)
      } else {
        await registerWithEmail(email, password)
      }
      onSuccess?.()
    } catch (err) {
      setError(
        mode === 'login'
          ? 'ログインに失敗しました。メールアドレスとパスワードを確認してください。'
          : '登録に失敗しました。パスワードは6文字以上にしてください。'
      )
    } finally {
      setLoading(false)
    }
  }

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      style={{ background: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(4px)' }}
      onClick={onClose}
    >
      <div
        className="w-full max-w-sm rounded-2xl p-6"
        style={{
          background: 'linear-gradient(145deg, #1a1f35, #111827)',
          border: '1px solid rgba(255,255,255,0.1)',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="text-xl font-black text-white text-center mb-1">
          {mode === 'login' ? 'ログイン' : '新規登録'}
        </h3>
        <p className="text-center text-white/40 text-xs mb-5">
          ログインすると全問題に挑戦できます
        </p>

        <button
          onClick={handleGoogle}
          disabled={loading}
          className="w-full py-3 rounded-lg font-bold text-sm mb-4 disabled:opacity-50"
          style={{ background: '#fff', color: '#1a1f35' }}
        >
          Googleで{mode === 'login' ? 'ログイン' : '登録'}
        </button>

        <div className="flex items-center gap-3 my-4">
          <div className="flex-1 h-px bg-white/10" />
          <span className="text-white/30 text-xs">または</span>
          <div className="flex-1 h-px bg-white/10" />
        </div>

        <form onSubmit={handleEmail} className="space-y-3">
          <input
            type="email"
            required
            placeholder="メールアドレス"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-3 py-2.5 rounded-lg text-sm text-white bg-white/5 border border-white/10 focus:border-chem-green outline-none"
          />
          <input
            type="password"
            required
            placeholder="パスワード"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full px-3 py-2.5 rounded-lg text-sm text-white bg-white/5 border border-white/10 focus:border-chem-green outline-none"
          />
          {error && <p className="text-red-400 text-xs">{error}</p>}
          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 rounded-lg font-bold text-sm text-white disabled:opacity-50"
            style={{ background: 'linear-gradient(135deg, #34D399, #14B8A6)' }}
          >
            {mode === 'login' ? 'ログイン' : '登録する'}
          </button>
        </form>

        <button
          onClick={() => {
            setMode(mode === 'login' ? 'register' : 'login')
            setError('')
          }}
          className="w-full text-center text-white/50 text-xs mt-4 hover:text-white/80"
        >
          {mode === 'login'
            ? 'アカウントをお持ちでない方はこちら'
            : 'すでにアカウントをお持ちの方はこちら'}
        </button>
      </div>
    </div>
  )
}
